export default {
  setTrainingsListState(state, data) {
    state.trainingsList = data.length ? data : [state.trainingsItem];
    state.trainingsErrorsList = state.trainingsList.map(() => state.trainingsErrorsItem);
  },
  addEmptyTrainingItem(state) {
    state.trainingsList = [state.trainingsItem, ...state.trainingsList];
    state.trainingsErrorsList = [state.trainingsErrorsItem, ...state.trainingsErrorsList];
  },
  mutateTrainingsByIndexState(state, data) {
    let list = [...state.trainingsList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.trainingsList = list;
  },
  deleteTrainingItem(state, index) {
    state.trainingsList.splice(index, 1);
    state.trainingsErrorsList.splice(index, 1);
  },
  mutateTrainingsErrorItem(state, data) {
    let list = [...state.trainingsErrorsList];
    list[data.index] = {...list[data.index], ...data.changedField};
    state.trainingsErrorsList = list;
  }
};
